import { Box, Grid, Stack, styled } from '@mui/material';

export const GNBMenuWrapper = styled(Stack)`
  position: relative;
  flex-direction: column;
  width: 400px;
  max-width: 100vw;
  max-height: calc(100vh - 140px);
  background-color: transparent;
  overflow: hidden;

  .header {
    flex: none;
    width: 100%;
    height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
    background: transparent url('/images/bg_blur_x1.png') repeat left top;
    z-index: 2;

    button {
      width: 28px;
      height: 28px;
      padding: 2px;
    }
  }

  .content {
    flex: 1;
    background-color: var(--dk-bg, #ffffff);
    padding-bottom: 56px;
    overflow-y: auto;

    .menu-tab {
      position: sticky;
      top: 0;
      background-color: var(--dk-bg, #ffffff);
      overflow-y: hidden;
      z-index: 2;
    }
  }
`;

export const GNBMenuTabItem = styled(Box)`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background-color: var(--dk-bg, #fff);
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: var(--dk-text-strong, #5f636b);
  user-select: none;
  &:hover {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }
  .active & {
    border-color: #34383d;
    background-color: #34383d;
    color: #fff;
  }
`;

export const GNBMenuItem = styled(Grid)`
  a,
  button {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    padding: 0;
    line-height: 24px;
    text-align: left;
    letter-spacing: -0.16px;
    font-weight: 400;
    font-size: 16px;
    color: var(--dk-text, black);
    &:hover {
      background-color: var(--dk-bg-muted, #f3f5f6);
    }
  }
`;
